<template>
  <div class="notice">
    <!-- <div class="owner">
      <div class="info">
        <img class="owner-img" src='https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/profilePic/imgs/161855310665875192_OLAPXT.jpg'></img>
        <div>肉眼</div>
      </div>
      <div>群主</div>
    </div> -->
    <div>
      <textarea 
        type="text" 
        v-model="notice"
        class="ipt textarea textarea2 textarea4" 
        style="margin-top:20px" 
        :maxlength="100" 
        placeholder="请输入" 
        placeholder-style='font-size:13px' 
      />
    </div>
    <div class="bot">
      <div class="bot-btn" style="border-top:0" @click='save'>保存</div>
    </div>
  </div>
</template>

<script>
import  { modifyChatSessionDetails} from '@/api/seller'
export default {
  data() {
    return {
      notice:"",
      query: {},
      disabled: false,
    }
  },
  computed: {

  },
  mounted(opt) {
    this.query = this.$route.query
    this.notice = this.$store.state.seller.newNotice
  },
  methods: {
    // 保存
    async save() {
      const params = {
        ...this.query,
        notice: this.notice
      }
      if(this.disabled) {
        return
      }
      this.disabled = true
      try {
        await modifyChatSessionDetails(params)
        this.$toast('操作成功')
        this.$store.commit('seller/setNotice', this.notice || '')
        setTimeout(() => {
          this.$router.go(-1)
        }, 1000)
      } catch (error) {
        this.disabled = false
      }
      
    }
  },
  components: {

  }
}
</script>

<style scoped lang='less'>
.notice {
  font-size: 28px;
  color: #222;
  padding: 10px;
}
.owner {
  border: 1px solid #e5e5e5;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  &-img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 20px;
  }
}
.info {
  display: flex;
  align-items: center;
}
.textarea {
  height: 300px;
  width: 100%;
  padding-top: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-sizing: border-box;
  padding-left: 20px;
  flex: 1;
  color: #666;
  box-sizing: border-box;
}
.bot {
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  background: #fff;
  border-top: 1px solid #ebebeb;
  &-btn {
    border: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    justify-content: center;
    color: red;
    height: 80px;
  }
}
</style>
